export default __webpack_public_path__ + "static/media/1049.548c320f.png";